require('./components/CustomCheckbox.jsx');
require('./components/CourseListLanding/CustomListLanding')


function hideNotification(id) {
    const elm = document.getElementById(id)
    if(id) {
        elm.classList.add('hidden')
    }
}

window.hideNotification = hideNotification

function showNotification(id) {
    const elm = document.getElementById(id)
    if(id) {
        elm.classList.remove('hidden')
    }
}

window.showNotification = showNotification

import amplitudClient from "./amplitude";
// admin


window.trackEvent = function (name, payload) {
    try{
        if(window.__DEV_ENV__ === 1) return;
        amplitudClient.logEvent(name, payload)
        gtag('event', name, payload)
        if(fbq) fbq('trackCustom', name)
    } catch (e) {
        console.log('error tacking evetns')
    }

}

let paramsEvent = { path: location.pathname }


const urlParams = new URLSearchParams(window.location.search);
const keys = urlParams.keys();
for(let key of keys) {
    if(key.includes('utm')) {
        paramsEvent[key] = urlParams.get(key)
    }
}




window.trackEvent('LOAD_URL', paramsEvent);



// check  UTM and add it to the session
const utm = urlParams.get('utm_source');
console.log('checking utm')
if(utm) {
    console.log('UTM', utm)
    fetch('/ajax/add-utm', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            utm
        })
    }).then(r => console.log('registered utm'))
}
